import { journeyElementsStore } from '../JourneyElementsStore';

export const useLocationById = (id: string) => {
	const locations = journeyElementsStore(x => x.locations);
	return locations.find(x => x.id === id);
};
